module.exports = __webpack_public_path__ + "static/media/GRADING11.a8e3e6d8.png";